import { createFileRoute } from "@tanstack/react-router"

import { CallsListView } from "@/features/voxsense/components/calls-list-view"
import {
  filtersFromSearch,
  parseCallsSearch,
  searchFromFilters,
} from "@/features/voxsense/utils/calls-search"

export const Route = createFileRoute("/_shell/voxsense/calls/")({
  // All optional: the overview links here with its threshold and window,
  // the sidebar's views with a risk band, window or tone; a plain link
  // to /voxsense/calls needs no search.
  validateSearch: parseCallsSearch,
  component: CallsRoute,
})

function CallsRoute() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  const filters = filtersFromSearch(search)
  return (
    <CallsListView
      filters={filters}
      onFiltersChange={(next) =>
        void navigate({
          search: searchFromFilters({ ...filters, ...next }),
          replace: true,
          resetScroll: false,
        })
      }
    />
  )
}
